import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import { Tween, Easing } from '@tweenjs/tween.js';
import Point from '../../../Utility/Point';

export class ArrowBounceLoop extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        meta = meta ? meta : {};
        const transform = gameObject.getComponent(TransformComponent);
        const tween: Tween = this.getTween(transform.position);
        const initialPos: Point = transform.position.clone() as Point;
        const offset: Point = meta.offset ? meta.offset : new Point(0, 50);
        const speed: number = meta.speed ? meta.speed : 400;

        while (true) {
            tween.easing(Easing.Quadratic.InOut);
            tween.to(
                { x: initialPos.x + offset.x, y: initialPos.y + offset.y },
                speed
            );
            yield* this.startTween(tween);
            tween.easing(Easing.Quadratic.InOut);
            tween.to({ x: initialPos.x, y: initialPos.y }, speed);
            yield* this.startTween(tween);
        }
    }
}
